<tcc-simplePanel [size]="panalSize" [buttons]="['close']" (buttonClick)="close()">

    <div panel-header *ngIf="state === 'ready'">
        Ledger View: <b>{{currentView}}</b>
        <div style="text-align: center;">
            <app-add-accounts-dialog></app-add-accounts-dialog>
            <button type="button" 
                    (click)="showAddAccountDialog()"
                    style="float: right;">Add</button>
        </div>
        <div>
            <div class="row" style="text-align: left;">
                <div class="col-1">
                    <a (click)="remove()">
                        <i class="fa fa-trash" title="Select below the accounts to remove!"></i>
                    </a>
                    <br />
                    <a (click)="clearAll()">
                        <i class="fa fa-circle-notch" title="Clear all selections!"></i>
                    </a>
                </div>
                <div class="col-3">
                    <b>Name</b>
                </div>
                <div class="col-1">
                    <b>Account Code</b>
                </div>
                <div class="col-1">
                    <b>Parent Account Code</b>
                </div>
                <div class="col-1">
                    <b>Is Negated</b>
                </div>
                <div class="col-1">
                    <b>Sort Index</b>
                </div>
                <div class="col-1">
                    <b>Is ReadOnly</b>
                </div>
                <div class="col-3">
                    <b>Custom Validation</b>
                </div>
            </div>
        </div>

    </div>

    <div panel-body *ngIf="state === 'ready'">
        <div class="dialog-content">
            <div *ngFor="let a of filteredApplicationViews">
                <div class="row" style="text-align: left;">
                    <div class="col-1">
                        <input type="checkbox" [id]="a.accountCode + '_' + a.parentAccountCode + '_selected'"
                            [(ngModel)]="a.isChecked"
                            (change)="onSelectedAccountSelected(a.accountCode, a.parentAccountCode)" />
                    </div>
                    <div class="col-3">
                        {{a.name}}
                    </div>
                    <div class="col-1">
                        {{a.accountCode}}
                    </div>
                    <div class="col-1">
                        {{a.parentAccountCode}}
                    </div>
                    <div class="col-1">
                        {{a.isNegated}}
                    </div>
                    <div class="col-1">
                        {{a.sortIndex}}
                    </div>
                    <div class="col-1">
                        {{a.isReadOnly}}
                    </div>
                    <div class="col-3">
                        {{a.customValidation}}
                    </div>
                </div>
            </div>
        </div>

    </div>

</tcc-simplePanel>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>